import { Loader } from 'lucide-react';
import StaticBlob from '../utils/StaticBlob';

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-[var(--color-paper-bg)] flex items-center justify-center transition-colors duration-500">
      {/* Subtle breathing gradient/aura in background — pre-blurred SVG
          so the blur isn't re-rasterized on every paint. */}
      <div className="absolute top-0 left-0 right-0 bottom-0 pointer-events-none overflow-hidden">
        <StaticBlob color="var(--color-accent-warm)" tintAlpha={0.18} className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%]" />
        <StaticBlob color="var(--color-ink-light)" tintAlpha={0.18} className="absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%]" />
      </div>

      <div className="relative z-10 text-center">
        <div className="inline-flex p-4 bg-[var(--color-ink-main)]/5 rounded-3xl shadow-lg border border-[var(--color-ink-subtle)]/10 mb-6 animate-pulse shape-organic">
          <Loader className="w-12 h-12 text-[var(--color-ink-main)]" />
        </div>
        <h1 className="text-3xl font-bold font-serif text-[var(--color-ink-main)] mb-2">Loading Steadily.me...</h1>
        <div className="flex justify-center space-x-2">
          <div className="w-3 h-3 bg-[var(--color-accent-warm)] rounded-full animate-bounce" style={{ borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%' }}></div>
          <div className="w-3 h-3 bg-[var(--color-ink-light)] rounded-full animate-bounce delay-100" style={{ borderRadius: '40% 60% 70% 30% / 40% 70% 30% 60%' }}></div>
          <div className="w-3 h-3 bg-[var(--color-ink-subtle)] rounded-full animate-bounce delay-200" style={{ borderRadius: '50% 50% 60% 40% / 60% 40% 50% 50%' }}></div>
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;
